import gql from 'graphql-tag';

export default fields => gql`
query ($filter: TableCampaignFilterInput, $limit: Int, $nextToken: String) {
  listCampaigns (filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      __typename
      ${[...['id', 'name'].concat(fields)]}     
    }
    nextToken
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Campaigns/AllQuery.js